"use client";
import * as React from "react";
import { IPost } from "@/types/post";
import { EntrySmallCard } from "../card/entrySmallCard";
import { usePublicationsFilter } from "@/contexts/publicationsSearch";
// import { getAllFilteredPublications } from "@/utils/cms";
// import { ENTRIES_PER_PAGE } from "@/constants";
import { gql, GraphQLClient } from "graphql-request";
import Pagination from "../nav/pagination";
import { ENTRIES_PER_PAGE } from "@/constants";
import { animateScroll } from "react-scroll";

const endpoint = `https://graphql.contentful.com/content/v1/spaces/${process.env.NEXT_PUBLIC_CF_SPACE_ID}`;
const client = new GraphQLClient(endpoint, {
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${process.env.NEXT_PUBLIC_CF_PREVIEW_ACCESS_TOKEN}`,
  },
});

export const EntriesList = ({
  entries,
  totalEntriesNumber: initialTotalEntriesNumber,
  initialPage,
}: {
  entries: IPost[];
  totalEntriesNumber: number;
  initialPage?: number;
}) => {
  const { entryTypes, page, setPage, setLoading } = usePublicationsFilter();
  const [filteredEntries, setFilteredEntries] = React.useState<IPost[]>([]);
  const [initialEntries, setInitialEntries] = React.useState<boolean>(true);
  const [totalEntriesNumber, setTotalEntriesNumber] = React.useState<number>(
    initialTotalEntriesNumber
  );

  const whereClause = entryTypes
    ? `where:{
              contentfulMetadata:{
                tags: {
                  id_contains_some: [${entryTypes?.map((type) => `"${type}"`)}]
                } 
              }
            }`
    : "";

  React.useEffect(() => {
    async function getCmsData() {
      // alert(`get cms data ${page}`);
      const query = gql`
        {
          postCollection(
            limit: ${ENTRIES_PER_PAGE}
            skip: ${(page - 1) * ENTRIES_PER_PAGE}
            ${whereClause}
            ) {
              total
              items{
                __typename
                sys{ id publishedAt }
                contentfulMetadata{
                  tags{
                    name id
                  }
                }
                title
                slug
                image{ url width height title }
              }
            }
        }
    `;
      setLoading(true);
      const data: { postCollection: { total: number; items: IPost[] } } =
        await client.request(query);
      setFilteredEntries(data.postCollection.items);
      setTotalEntriesNumber(data.postCollection.total);
      setLoading(false);
      setInitialEntries(false);
      // scroller.scrollTo("page-", { smooth: true, offset: -100 });
      animateScroll.scrollToTop();
    }
    if (entryTypes && entryTypes.length > 0) {
      getCmsData();
    } else {
      // setPage(1);
      getCmsData();
      setFilteredEntries([]);
      setTotalEntriesNumber(initialTotalEntriesNumber);
    }
  }, [entryTypes, page]);

  React.useEffect(() => {
    if (initialPage) {
      setPage(initialPage);
    }
  }, [initialPage]);

  const displayEntries = filteredEntries.length ? filteredEntries : entries;
  // const totalPages = Math.ceil(totalEntriesNumber / ENTRIES_PER_PAGE);

  return (
    <>
      <h1 id="page-title" className="text-3xl font-medium text-brand-blue">
        Publications{" "}
        {/* <span className="text-brand-brown opacity-40">
          ({totalEntriesNumber})
        </span> */}
      </h1>
      {/* <p className="text-gray-400 text-sm">
        Page {page}/{totalPages}
      </p> */}
      <div className="space-y-6 xl:space-y-8">
        {/* <pre>{JSON.stringify(filteredEntries, null, 2)}</pre> */}
        {displayEntries?.map((entry: IPost, index: number) => (
          <React.Fragment key={entry?.sys?.id}>
            <EntrySmallCard entry={entry} />
            {index + 1 < entries.length && <hr />}
          </React.Fragment>
        ))}
        <Pagination
          perPage={ENTRIES_PER_PAGE}
          currentPage={page}
          entriesNumber={totalEntriesNumber}
          setPage={setPage}
          initialEntries={initialEntries}
        />
      </div>
    </>
  );
};
